<section class="specialists-section" #specialistsSection>
    <div class="container">
        <h2 class="section-title">Red de Especialistas</h2>
        <p class="section-subtitle">
            Contamos además con una red de profesionales que nos permite brindar soluciones integrales en:
        </p>

        <!-- ================= VISTA DE ESCRITORIO ================= -->
        @if (!isMobile) {
        <div class="network-container desktop-network" [class.visible]="isVisible">
            <div class="network-items">
                <!-- Item 1 -->
                <div class="network-item" [class.visible]="isVisible" style="--delay: 0s">
                    <div class="item-icon yellow">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="2" y="5" width="20" height="14" rx="2"></rect>
                            <line x1="2" y1="10" x2="22" y2="10"></line>
                        </svg>
                    </div>
                    <div class="item-text top"><span>Despacho<br>Aduanero</span></div>
                </div>
                <!-- Item 2 -->
                <div class="network-item" [class.visible]="isVisible" style="--delay: 0.3s">
                    <div class="item-text bottom"><span>Derecho<br>Empresarial</span></div>
                    <div class="item-icon gray">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
                            <path d="M9 22v-4h6v4"></path>
                            <path d="M8 6h.01"></path>
                            <path d="M16 6h.01"></path>
                            <path d="M12 6h.01"></path>
                            <path d="M12 10h.01"></path>
                            <path d="M12 14h.01"></path>
                            <path d="M16 10h.01"></path>
                            <path d="M16 14h.01"></path>
                            <path d="M8 10h.01"></path>
                            <path d="M8 14h.01"></path>
                        </svg>
                    </div>
                </div>
                <!-- Item 3 -->
                <div class="network-item" [class.visible]="isVisible" style="--delay: 0.6s">
                    <div class="item-icon yellow">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                        </svg>
                    </div>
                    <div class="item-text top"><span>Derecho<br>Tributario</span></div>
                </div>
                <!-- Item 4 -->
                <div class="network-item" [class.visible]="isVisible" style="--delay: 0.9s">
                    <div class="item-text bottom"><span>Consultoría<br>Impositiva</span></div>
                    <div class="item-icon gray">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                            <polyline points="9 16 11 18 15 14"></polyline>
                        </svg>
                    </div>
                </div>
                <!-- Item 5 -->
                <div class="network-item" [class.visible]="isVisible" style="--delay: 1.2s">
                    <div class="item-icon yellow">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                            <polyline points="9 12 11 14 15 10"></polyline>
                        </svg>
                    </div>
                    <div class="item-text top"><span>Auditoría y<br>Seguros</span></div>
                </div>
            </div>

            <!-- Línea SVG ZigZag -->
            <svg class="network-line" viewBox="0 0 1000 200" preserveAspectRatio="none">
                <path d="M 0 100 L 125 150 L 312 50 L 500 150 L 687 50 L 875 150 L 1000 100" stroke="#ffffff"
                    stroke-width="2" fill="none" class="animated-line" [class.visible]="isVisible" />
            </svg>
        </div>
        }
        @else {
        <!-- ================= VISTA MÓVIL / TABLET ================= -->
        <div class="network-container mobile-network" [class.visible]="isVisible">
            <div class="mobile-items">
                <!-- Item 1 -->
                <div class="mobile-item" [class.visible]="isVisible" style="--delay: 0s">
                    <div class="item-icon yellow">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="2" y="5" width="20" height="14" rx="2"></rect>
                            <line x1="2" y1="10" x2="22" y2="10"></line>
                        </svg>
                    </div>
                    <div class="item-text"><span>Despacho Aduanero</span></div>
                </div>
                <!-- Item 2 -->
                <div class="mobile-item" [class.visible]="isVisible" style="--delay: 0.2s">
                    <div class="item-icon gray">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
                            <path d="M9 22v-4h6v4"></path>
                            <path d="M8 6h.01"></path>
                            <path d="M16 6h.01"></path>
                            <path d="M12 6h.01"></path>
                            <path d="M12 10h.01"></path>
                            <path d="M12 14h.01"></path>
                            <path d="M16 10h.01"></path>
                            <path d="M16 14h.01"></path>
                            <path d="M8 10h.01"></path>
                            <path d="M8 14h.01"></path>
                        </svg>
                    </div>
                    <div class="item-text"><span>Derecho Empresarial</span></div>
                </div>
                <!-- Item 3 -->
                <div class="mobile-item" [class.visible]="isVisible" style="--delay: 0.4s">
                    <div class="item-icon yellow">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                        </svg>
                    </div>
                    <div class="item-text"><span>Derecho Tributario</span></div>
                </div>
                <!-- Item 4 -->
                <div class="mobile-item" [class.visible]="isVisible" style="--delay: 0.6s">
                    <div class="item-icon gray">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                            <polyline points="9 16 11 18 15 14"></polyline>
                        </svg>
                    </div>
                    <div class="item-text"><span>Consultoría Impositiva</span></div>
                </div>
                <!-- Item 5 -->
                <div class="mobile-item" [class.visible]="isVisible" style="--delay: 0.8s">
                    <div class="item-icon yellow">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                            <polyline points="9 12 11 14 15 10"></polyline>
                        </svg>
                    </div>
                    <div class="item-text"><span>Auditoría y Seguros</span></div>
                </div>
            </div>

            <!-- Línea Vertical (CSS puro) -->
            <div class="mobile-line"></div>
        </div>
        }
    </div>
</section>